import React, { useEffect } from 'react'
function Hello() {
  return (
    <div className='hello-page'>
      <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
        <h1 className='hello'>Welcome</h1>
      </div>
    </div>
  )
}

export default Hello